
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export type Company = {
  id: string;
  name: string;
  street?: string | null;
  postal_code?: string | null;
  city?: string | null;
  country?: string | null;
  assignee?: string | null;
  logo_url?: string | null;
  vat_number?: string | null;
  website_url?: string | null;
  custom_fields?: Record<string, any>;
};

export const useCompanyDetail = (companyId: string | undefined) => {
  const [loading, setLoading] = useState(true);
  const [company, setCompany] = useState<Company | null>(null);

  const fetchCompanyDetails = async () => {
    if (!companyId) return;
      
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('companies')
        .select('id, name, street, postal_code, city, country, assignee, logo_url, vat_number, website_url, custom_fields')
        .eq('id', companyId)
        .single();
      
      if (error) throw error;
      setCompany(data);
    } catch (error) {
      console.error("Error fetching company details:", error);
      if (companyId) {
        const mockCompany = getMockCompany(companyId);
        setCompany(mockCompany);
      }
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchCompanyDetails();
  }, [companyId]);
  
  const getMockCompany = (companyId: string): Company => {
    const mockCompanies = {
      "1": { 
        id: "1", 
        name: "Barco", 
        street: "Boulevard du Souverain",
        postal_code: "1160",
        city: "Auderghem",
        country: "Belgium",
        assignee: "-",
        logo_url: null
      },
      "2": { 
        id: "2", 
        name: "Belfius", 
        street: "Place Roger",
        postal_code: "1000",
        city: "Bruxelles",
        country: "Belgium",
        assignee: "Kevin Thibaut",
        logo_url: null
      },
      "3": { 
        id: "3", 
        name: "Besix", 
        street: "Avenue des Arts",
        postal_code: "1000",
        city: "Bruxelles",
        country: "Belgium",
        assignee: "-",
        logo_url: null
      },
      "4": { 
        id: "4", 
        name: "Logic Solutions", 
        street: "Rue de la Science",
        postal_code: "1040",
        city: "Bruxelles",
        country: "Belgium",
        assignee: "Kevin Thibaut",
        logo_url: null
      }
    };
    
    return mockCompanies[companyId as keyof typeof mockCompanies] || {
      id: companyId,
      name: "Unknown Company",
      street: "",
      postal_code: "",
      city: "",
      country: "",
      assignee: "-",
      logo_url: null
    };
  };

  return {
    company,
    loading,
    refreshCompany: fetchCompanyDetails
  };
};
